module.exports = __webpack_public_path__ + "4b059d58df70bed11517376da33baea6.pdf";